<template>
  <div id="work-gallery">
    <div id="contents">
      <canvas></canvas>
      <WorkGalleryDetail :detail-id=detailId ></WorkGalleryDetail>
      <button class="arrow bottom" v-on:click="increment">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
        width="60px" height="60px"    viewBox="0 0 64 64" xml:space="preserve">
          <g
       id="g6"
       transform="matrix(1,0,0,-1,0,64.5)"
       style="fill:#ffffff"><g
         id="Icon-Chevron-Left"
         transform="translate(237,335)"
         style="fill:#ffffff"><polyline
           class="st0"
           id="Fill-35"
           points="-191.3,-296.9 -193.3,-294.9 -205,-306.6 -216.7,-294.9 -218.7,-296.9 -205,-310.6      -191.3,-296.9    "
           style="fill:#ffffff" /></g></g>
         </svg>
      </button>
    </div>
    <div class="measure">
      <div class="line"></div>
      <div class="stop-point" v-on:click="gotoIndex" data-index="1" ></div>
      <div class="stop-point" v-on:click="gotoIndex" data-index="2"></div>
      <div class="stop-point" v-on:click="gotoIndex" data-index="3"></div>
      <div class="stop-point" v-on:click="gotoIndex" data-index="4"></div>
      <div class="stop-point" v-on:click="gotoIndex" data-index="5"></div>
      <div class="stop-point" v-on:click="gotoIndex" data-index="6"></div>
      <div class="stop-point" v-on:click="gotoIndex" data-index="7"></div>
      <div class="stop-point" v-on:click="gotoIndex" data-index="8"></div>
      <div class="dot grabber"></div>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import VideoLoader from "@/components/VideoLoader"
import WorkGalleryDetail from "@/components/WorkGalleryDetail"
import * as THREE from 'three';
import gsap from "gsap";
import { TimelineMax } from "gsap";
import img1 from "@/assets/images/gallery/eachscape.png";
import img2 from "@/assets/images/gallery/motorola.jpg";
import img3 from "@/assets/images/gallery/g3.jpg";
import img4 from "@/assets/images/gallery/g1.jpg";
import img5 from "@/assets/images/gallery/g2.jpg";
import video1 from "@/assets/images/gallery/g4.mp4";
import video2 from "@/assets/images/gallery/g5.mp4";
import video3 from "@/assets/images/gallery/g6.mp4";

import fragment from '!raw-loader!@/assets/galleryshaders/fragment.glsl';
import vertex from '!raw-loader!@/assets/galleryshaders/vertex.glsl';

const loader = new THREE.TextureLoader();
const gallery = [
  null,
  null,
  null,
  loader.load( img1 ),
  loader.load( img2 ),
  loader.load( img3 ),
  loader.load( img4 ),//import( '@/assets/images/gallery/img.jpg')),
  loader.load( img5 )
];

const gallerySize = gallery.length;

const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
                            window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;


let pos, geometry, geometry1, material,plane,tex1,tex2;
const destination = {x:0, y:0};
const textures = [];


@Component ({
  components: {
    WorkGalleryDetail
  },
  watch: {
    "$store.state.windowWidth": function(){
      this.resize();
    }
  }
})
export default class WorkGallery extends Vue{
  loaded   = false;
  detailId = 0;
  mounted() {

    this.animating  = false;
    this.cursorTimer = null;
    this.time   = 0;
    this.speed = 0;
    this.slideAnimationRequest = null;
    this.renderAnimationRequest = null;
    this.position = 0;
    this.detailId = 0;
    this.tickerEl = this.$el.querySelector('.dot');
    this.videoTextures = [];
    this.canvas = this.$el.querySelector('canvas');
    this.material = null;
    this.timeline  = gsap.timeline();
    this.contentWidth  = this.$el.clientWidth;
    this.contentHeight = this.$el.clientHeight;
    this.videoLoaderWaitD = [];
    this.cursorDelta = 0;
    this.stopPoints = this.$el.querySelectorAll('.stop-point');
    this.forceIncremental = false;
    this.loadVideos();
    Promise.all( this.videoLoaderWaitD ).then( function(){
      this.loaded = true;
      this._initThree();
      this.resize();
      this.bindEvent();
      this.animate();
      //this.raf();   
      this.animateTicker();
    }.bind( this ))
 
  }

  beforeDestroy(){
    console.info( ' canceling work gallery');
    this.unbindEvent();
    this.cancelRenderAnimation();
    this.cancelAnimationSlide();
    this.unloadVideos();
    this._cleanupThree();
  }

  loadVideos(){

    const videos = [ video1, video2, video3 ];
    for( let i = 0; i < 3; i ++ ){
      const v = videos[i];
      const videoIndex   = i;
      const videoTexture = VideoLoader.load( v, this.$el );
      const d = videoTexture.loadVideo( function(){
        const texture = videoTexture.getTexture();
        texture._type = 'video';
        gallery[videoIndex]  =  videoTexture.getTexture();
      }.bind(this));
      this.videoLoaderWaitD.push( d );
      this.videoTextures.push( videoTexture );
    }

    this.videoTextures.forEach( ( v ) => v.start() );
  }

  unloadVideos(){
    const size = this.videoTextures.length;
    this.videoTextures.forEach( ( v ) => v.destroy() );
    this.videoTextures = [];
    gallery.splice(0, size );
    console.info('gallerySize = ' + gallery.length );
  }

  animateTicker(){
    const lineEl = this.$el.querySelector(".line");

    gsap.from( lineEl, {
          duration: 1.5,
          width: 0,
          opacity: 0,
          ease: "power2.inOut",
          clearProps: "all"
        })
     gsap.from( '.stop-point', {
              duration: 1.5,
              marginLeft: -150,
              opacity: 0,
              ease: "power4.inOut",
              stagger: 0.3,
              clearProps: "all"
            });

  }

  increment() {
    this.cancelAnimationSlide();
    this.move( 0.25, true, true); 
  }

  decrement(){
    this.cancelAnimationSlide();
    this.move( -0.25, true, true ); 
  }

  gotoIndex( event ){
    const index    = parseInt( event.target.dataset.index );
    let position = ( index - this.position );
    if( ( this.position + position ) == 8 && this.position != 8 ){
      position -= Math.pow( 0.035, position);
      if( position < 1 ) {
        position = 0.25;
      }
    }
    this.move( position, true, false );

    // if( position < 0  ){
    //   position = position - 0.25;
    // } else if( position > 0 ) {
    //   position = position + 0.25
    // }
  }

  cancelRenderAnimation(){
    if( this.renderAnimationRequest != null ) {
      cancelAnimationFrame( this.renderAnimationRequest );
    }
    this.renderAnimationRequest = null;
    
  }

  cancelAnimationSlide(){
    if( this.slideAnimationRequest != null ){
      cancelAnimationFrame( this.slideAnimationRequest );
      this.slideAnimationRequest = null;
    }
    this.animating = false;
  }



  _cleanupThree(){
    this.renderer = null;
    this.camera   = null;
  }

  _initThree() {
    
    this.scene = new THREE.Scene();
    var canvasW = this.contentWidth  = window.innerWidth;
    var canvasH = this.contentHeight = window.innerHeight;
    if( canvasW < canvasH ) {
      canvasH = Math.abs( canvasH / 2 );
    }
    console.log( 'canvas Size = ( ' + canvasW + "," + canvasH + ')');

    this.renderer = new THREE.WebGLRenderer(
      {
        antialias: !1,
        alpha: !0,
        canvas: this.canvas
      });



    this.renderer.setSize( canvasW, canvasH );

    this.camera = new THREE.PerspectiveCamera( 
          70,
          canvasW / canvasH,
          0.001, 100
      );
    this.camera.position.set( 0, 0, 1 );

    this.material = new THREE.ShaderMaterial( {
      side: THREE.DoubleSide,
      uniforms: {
        time: { type: 'f', value: 0 },
        pixels: {type: 'v2', value: new THREE.Vector2(  canvasW, canvasH)},
        accel: {type: 'v2', value: new THREE.Vector2(0.5,2)},
        progress: {type: 'f', value: 0},
        uvRate1: {
          value: new THREE.Vector2(1,1)
        },
        texture1: {
          value:  gallery[0]
        },
        texture2: {
          value:  gallery[1]//@/assets/images/gallery/img1.jpg')
        },
      },
      //wireframe: true,
      vertexShader: vertex,
      fragmentShader: fragment
    });
    plane = new THREE.Mesh(new THREE.PlaneGeometry( 1,1, 1, 1 ), this.material);
    this.scene.add(plane);
    this.increment();

  }

  bindEvent(){
    this._wheelHandler = this.wheelHandler.bind(this);
    document.addEventListener('wheel', this._wheelHandler );
  }

  wheelHandler( event ){
    var direction = 1;
    if( event.deltaY < 0 ){
      direction = -1;
    }
    const deltaY = direction * Math.min( Math.abs( event.deltaY ), this.cursorDelta * 0.20 );
    console.info( 'deltaY = ' + deltaY + ", this.cursorDelta " + this.cursorDelta )
    var distance = deltaY * 0.001;
    this.move( distance, false, true );    
  }

  unbindEvent(){
    if(  this._wheelHandler  != null ) {
      document.addEventListener('wheel', this._wheelHandler );
    }
    this._wheelHandler  = null;
  }

  move( distance, override = false, forceIncremental = true ) {
    this.forceIncremental = forceIncremental;
    if( override ) {
      this.cancelAnimationSlide();
      this.speed = distance;
    } else {
      this.speed += distance;
    }
    //console.log( ' speed = ' + this.speed + ", distance ="+   distance + ", position = " + this.position );
    if( !this.animating ) {
      this.animating = true;
      this.raf();
    }
  }

  resize(){
    this.cursorDelta = Math.abs( jQuery( this.stopPoints[1] ).position().top -  jQuery( this.stopPoints[0] ).position().top )
    var w = this.contentWidth  = window.innerWidth;
    var h = this.contentHeight = window.innerHeight;
    if( w < h ) {
      h = Math.abs( h / 2 );
    }
    this.renderer.setSize( w, h );
    this.camera.aspect = w / h;

    this.material.uniforms.uvRate1.value.y = h / w;

    // calculate scene
    const dist  = this.camera.position.z - plane.position.z;
    const height = 1;
    this.camera.fov = 2*(180/Math.PI)*Math.atan(height/(2*dist));

    // if(w/h>1) {
    plane.scale.x = w/h;
    this.camera.updateProjectionMatrix();

  }

  animate() {
    this.time = this.time+0.05;
    this.material.uniforms.time.value = this.time;
    this.renderAnimationRequest = requestAnimationFrame( this.animate.bind(this) );
    this.renderGL();
  }

  renderGL() {
    this.renderer.render(this.scene, this.camera);
  }

  raf() {

    // this.position += this.speed;
    // this.speed *=0.75;

    // this.position = ( this.position + gallerySize ) % gallerySize; 
    // const i = Math.round( this.position ) ;
    // const dif = i - this.position;

    var nextPosition = this.position + this.speed;
    this.speed *= 0.75
    console.log("forceIncremental = " + this.forceIncremental )
    if ( this.forceIncremental === true ) {
      /* prevent from skipping one */
      if( nextPosition > this.position + 1 ) {
        nextPosition = this.position + 1;
      } else if ( nextPosition < this.position - 1 ) {
        nextPosition = this.position - 1;
      }
    }

    this.position = ( nextPosition + gallerySize ) % gallerySize; 
    const i =  Math.round( this.position )  ;
    const dif = i - this.position;


    // dif = dif<0? Math.max(dif,-0.02):Math.max(dif,+0.03);

    this.position += dif*0.035 ;
    if( Math.abs(i - this.position )< 0.01) {
      this.position = i;
      // if( Math.abs( this.position ) > 1 ) {

      // }
      this.speed = 0;
      this.animating = false;

    }


    this.material.uniforms.progress.value = this.position;
    const position    = Math.floor( Math.min( ( this.position + gallerySize ), this.position ) )
    const curslide = ( position - 1 + gallerySize ) % gallerySize;
    // const nextslide = ((( position + 1) % gallerySize -1 ) + gallerySize  ) % gallerySize;
    const nextslide = ( i - 1 ) % gallerySize;
    // console.info( curslide + "->" + nextslide );
    this.material.uniforms.texture1.value =gallery [curslide];
    this.material.uniforms.texture2.value = gallery[nextslide]; // this.videoTexture.getTexture(); //

    const progress = this.position % 1
    if( progress < 0.1 ) {
      this.detailId = curslide;
    } 
    if( progress > 0.9 ){
      this.detailId = nextslide;
    }
    if ( this.animating == false ) {
      this.moveCursor( this.position );
      return;
    }

    // console.log(speed,position);
    this.slideAnimationRequest = requestAnimationFrame( this.raf.bind(this) );
  }

  stopSliderTimeline(){
    if( this.cursorTimer ) {
      clearTimeout( this.cursorTimer )
      this.cursorTimer = null;
    }
    this.timeline.clear();

  }

  moveCursor( position ){
    this.stopSliderTimeline();
    console.log('position = ' + position );
    const el = this.stopPoints[ position - 1 ];
    const top = jQuery(el).position().top;
    this.timeline.to(this.tickerEl, 1, { top: top + "px" });
  }


}

</script>

     
<style lang="scss">
  #work-gallery{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    #contents {

      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      padding: 0px;
      margin: 0px;


      button {
        -webkit-appearance: none;
        background: transparent;
        border: 0;
        outline:0;
        &.arrow.bottom {
            cursor: pointer;
            position: absolute;
            top: auto;
            bottom: 0px;
            left: 50%;
            margin-left:-40px;
            width: 80px;
            height: 80px;
            padding:0px;
            text-align:center;
            overflow:hidden;
            svg {
              padding:0px;
              width:100%;
              height:100%;
            }
        }
        &.arrow {
            cursor: pointer;
            position: absolute;
            top: 50%;
            margin-top: -45px;
            width: 70px;
            height: 90px;
        }
        @media only screen and (max-width: 600px) {
          &.arrow {
            width: 35px;
            margin-top: -22px;
            height: 45px;

            svg {
              width: 35px;
              height: 45px;
            }
          }
        }


        &:hover polyline,
        &:focus polyline {
            stroke-width: 3;
          }

        &:active polyline {
            stroke-width: 6;
            transition: all 100ms ease-in-out;
          }

        &:active polyline {
            stroke-width: 6;
            transition: all 100ms ease-in-out;
          }

          polyline {
            transition: all 250ms ease-in-out;
          }

        }      


    }

    video,
    canvas {
      position: absolute;
      top: 0px;
      left: 0px;
    }
    canvas{
      width:100%;
      height:100%;
      display: block;
      opacity:.5;
    }

    .measure{
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: calc(80% - 20px);
      top: calc( 20px + 10% );
      right: 50px;
      justify-content: space-between;
      overflow: visible;
      width: 0px;

      .line{
        position: absolute;
        top: 0px;
        left: 0px;
        height: 100%;
        width: 1px;
        background-color: #fff;
        opacity: 1;
      }
      .stop-point{
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 0.3);
        border: 1px solid #FFF;
        pointer-events: all;
        cursor: pointer;
        z-index: 1;
      }
      .grabber {
        width: 10px;
        height: 10px; 
        background: red;
        position: absolute;
      }

      .dot{
        left:0px;
        background: white;
        margin-top:  0px;
        margin-left: -15px;
        width: 30px; 
        height: 30px;
      }

    }
  }
</style>